import React, { useState, useEffect } from 'react';
import axios from "../../../../axios-order";
import { Snackbar, Alert } from '@mui/material';

function Pvt({ handleBack, updateTableData, data, reasonsData, title, get_gstr9_report_data }) {
    const [reasonText, setReasonText] = useState('');
    // Initialize inputValues with API response values
    const [inputValues, setInputValues] = useState(
        data?.map(item => ({
            taxable_non_taxable_value: item.taxable_non_taxable_value != null ? item.taxable_non_taxable_value.toString() : '',
            central_tax: item.central_tax != null ? item.central_tax.toString() : '',
            state_tax_ut_tax: item.state_tax_ut_tax != null ? item.state_tax_ut_tax.toString() : '',
            integrated_tax: item.integrated_tax != null ? item.integrated_tax.toString() : '',
            cess: item.cess != null ? item.cess.toString() : '',
        })) || []
    );

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: '',
        severity: 'success',
    });

    const getAlphabeticSerial = (index) => {
        let result = '';
        let num = index;
        do {
            result = String.fromCharCode(65 + (num % 26)) + result;
            num = Math.floor(num / 26) - 1;
        } while (num >= 0);
        return result;
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbar({ ...snackbar, open: false });
    };

    const handleSubmit = async () => {
        const business_entity_id = localStorage.getItem('business_entity_id');
        const gstr9c_recon_id = localStorage.getItem('gstr9c_recon_id');

        // Validate required identifiers
        if (!business_entity_id || !gstr9c_recon_id) {
            setSnackbar({
                open: true,
                message: 'Missing required identifiers.',
                severity: 'error',
            });
            return;
        }

        const payload = {
            business_entity_id,
            gstr9c_recon_id,
            records: {
                "Pt.V.Additional Liability due to non-reconciliation": data.map((item, index) => ({
                    id: item.id,
                    gstr9c_recon_id: item.gstr9c_recon_id,
                    business_entity_id: item.business_entity_id,
                    description: item.description,
                    taxable_non_taxable_value: inputValues[index]?.taxable_non_taxable_value === '' ? 0 : parseFloat(inputValues[index]?.taxable_non_taxable_value) || 0,
                    central_tax: inputValues[index]?.central_tax === '' ? 0 : parseFloat(inputValues[index]?.central_tax) || 0,
                    state_tax_ut_tax: inputValues[index]?.state_tax_ut_tax === '' ? 0 : parseFloat(inputValues[index]?.state_tax_ut_tax) || 0,
                    integrated_tax: inputValues[index]?.integrated_tax === '' ? 0 : parseFloat(inputValues[index]?.integrated_tax) || 0,
                    cess: inputValues[index]?.cess === '' ? 0 : parseFloat(inputValues[index]?.cess) || 0,
                    amount_of_itc_total: item.amount_of_itc_total || null,
                    amount_of_itc_eligible: item.amount_of_itc_eligible || null,
                })),
            },
        };

        try {
            const response = await axios.post("/gstr9c_manual_data_update", payload);
            console.log('Submit response:', response.data);
            if (response.data.status === true) {
                setSnackbar({
                    open: true,
                    message: response.data.message || 'Values updated successfully.',
                    severity: 'success',
                });
                if (typeof get_gstr9_report_data === 'function') {
                    await get_gstr9_report_data();
                } else {
                    console.warn('get_gstr9_report_data is not a function');
                }
            } else {
                setSnackbar({
                    open: true,
                    message: response.data.message || 'Failed to update values.',
                    severity: 'error',
                });
            }
        } catch (error) {
            console.error('Error submitting data:', error);
            setSnackbar({
                open: true,
                message: 'An error occurred while submitting data.',
                severity: 'error',
            });
        }
    };

    // Define descriptions to hide Taxable Value column
    const hiddenColumnsDescriptions = [
        'G2.Supplies on which e-commerce operator is required to pay tax as per section 9(5) (including amendments, if any) [E-commerce operator to report]',
    ];

    const handleManualInputChange = (index, field, value) => {
        // Remove the rupee symbol before validation
        const numericValue = value.replace('₹', '').trim();

        // Validate: allow digits, one decimal point, and one negative sign at the start
        if (numericValue !== '' && !/^-?\d*\.?\d*$/.test(numericValue)) {
            alert('Please enter a valid number (digits, optional negative sign, and optional decimal point).');
            return;
        }

        // Update state with numeric value (without ₹)
        const newInputValues = [...inputValues];
        newInputValues[index] = { ...newInputValues[index], [field]: numericValue };
        setInputValues(newInputValues);

        const newData = [...data];
        const parsedValue = numericValue === '' ? '' : parseFloat(numericValue);
        newData[index] = { ...newData[index], [field]: parsedValue };

        if (typeof updateTableData === 'function') {
            updateTableData(newData);
        } else {
            console.warn('updateTableData is not a function. Data update skipped.');
        }
    };

    // const handleKeyDown = (e) => {
    //   const allowedKeys = [
    //     '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    //     'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab',
    //     '-', '.'
    //   ];
    //   const input = e.target.value.replace('₹', '');

    //   // Prevent multiple decimal points
    //   if (e.key === '.' && input.includes('.')) {
    //     e.preventDefault();
    //     return;
    //   }

    //   // Prevent multiple negative signs or negative sign not at start
    //   if (e.key === '-' && (input.includes('-') || e.target.selectionStart !== 0)) {
    //     e.preventDefault();
    //     return;
    //   }

    //   if (!allowedKeys.includes(e.key)) {
    //     e.preventDefault();
    //   }
    // };


    // Handle key press to allow digits, negative sign, decimal point
    const handleKeyDown = (e, index) => {
        if (index === 15 || index === 17) {
            e.preventDefault();
            console.log(`Keypress blocked for index ${index} (P or R)`);
            return;
        }
        const allowedKeys = [
            '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab',
            '-', '.'
        ];
        const input = e.target.value.replace('₹', '').trim();

        // Prevent multiple decimal points
        if (e.key === '.' && input.includes('.')) {
            e.preventDefault();
            return;
        }

        // Prevent multiple negative signs or negative sign not at start
        if (e.key === '-') {
            const cursorPosition = e.target.selectionStart;
            // Allow minus only at position 1 (after ₹) if there's no minus already
            if (input.includes('-') || cursorPosition !== 1) {
                e.preventDefault();
                return;
            }
        }

        // Limit decimal places to 2
        if (e.key >= '0' && e.key <= '9') {
            const parts = input.split('.');
            if (parts.length === 2 && parts[1].length >= 2) {
                // Check if cursor is after the decimal point
                const cursorPosition = e.target.selectionStart;
                const fullValue = e.target.value;
                const decimalPosition = fullValue.indexOf('.');
                // If there's text selected, allow replacement
                if (e.target.selectionStart === e.target.selectionEnd && cursorPosition > decimalPosition) {
                    e.preventDefault();
                    return;
                }
            }
        }

        if (!allowedKeys.includes(e.key)) {
            e.preventDefault();
        }
    };


    const inputStyle = {
        color: '#1e293b',
        fontWeight: '500',
        fontSize: '13px',
        textAlign: 'right',
        padding: '6px',
        border: '1px solid #e2e8f0',
        borderRadius: '6px',
        width: '100%',
        outline: 'none',
        minHeight: '28px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end'
    };

    const inputFocusBlur = {
        onFocus: (e) => {
            e.target.style.borderColor = '#88d8a3';
            e.target.style.boxShadow = '0 0 0 2px rgba(136, 216, 163, 0.1)';
            if (e.target.value) {
                e.target.setSelectionRange(1, e.target.value.length); // Skip the rupee symbol
            }
        },
        onBlur: (e, index, field) => {
            e.target.style.borderColor = '#e2e8f0';
            e.target.style.boxShadow = 'none';
            handleManualInputChange(index, field, e.target.value);
        },
    };

    return (
        <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
            <div style={{ backgroundColor: 'white', borderRadius: '20px', padding: '30px', width: '100%', boxShadow: '0 20px 40px rgba(0,0,0,0.1)' }}>
                <button
                    onClick={handleBack}
                    style={{
                        marginBottom: '20px',
                        padding: '8px 16px',
                        backgroundColor: '#f8fafc',
                        border: '1px solid #e2e8f0',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: '14px',
                        color: '#64748b',
                    }}
                >
                    Back
                </button>

                <h2 style={{ marginBottom: '20px', color: '#1e293b', fontSize: '20px', fontWeight: '700', textAlign: 'center' }}>
                    {title || 'Table 11 - Additional Amount Payable but Not Paid'}
                </h2>

                {/* Table Header */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '60px 2fr 1fr 1fr 1fr 1fr 1fr',
                    gap: '10px',
                    fontWeight: '600',
                    color: '#475569',
                    padding: '15px 10px',
                    borderBottom: '2px solid #e2e8f0',
                    fontSize: '14px',
                    backgroundColor: '#f8fafc',
                    borderRadius: '8px',
                    marginBottom: '10px',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                }}>
                    <span style={{ textAlign: 'center' }}>S.No.</span>
                    <span>Description</span>
                    <span style={{ textAlign: 'center' }}>Taxable Value</span>
                    <span style={{ textAlign: 'center', gridColumn: 'span 4' }}>Paid through Cash/ITC (₹)</span>
                </div>

                {/* Sub-header for tax columns */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: '60px 2fr 1fr 1fr 1fr 1fr 1fr',
                    gap: '10px',
                    fontWeight: '600',
                    color: '#475569',
                    padding: '5px 10px',
                    fontSize: '12px',
                    backgroundColor: '#f8fafc',
                    marginBottom: '10px',
                }}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span style={{ textAlign: 'center' }}>Central Tax</span>
                    <span style={{ textAlign: 'center' }}>State/UT Tax</span>
                    <span style={{ textAlign: 'center' }}>Integrated Tax</span>
                    <span style={{ textAlign: 'center' }}>Cess</span>
                </div>

                {/* Table Body */}
                <div style={{
                    maxHeight: '500px',
                    overflowY: 'auto',
                    marginTop: '10px',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#64748b #f1f5f9',
                }}>
                    <style>
                        {`
              div::-webkit-scrollbar {
                width: 12px;
              }
              div::-webkit-scrollbar-track {
                background: #f1f5f9;
                borderRadius: 6px;
              }
              div::-webkit-scrollbar-thumb {
                background: #64748b;
                borderRadius: 6px;
              }
              div::-webkit-scrollbar-thumb:hover {
                background: #475569;
              }
            `}
                    </style>
                    {data && Array.isArray(data) && data.length > 0 ? (
                        data.map((item, index) => {
                            const getRowColor = (index) => {
                                const colors = ['#e0e7ff', '#e9d5ff', '#f3e8ff', '#ede9fe', '#ddd6fe'];
                                return colors[index % colors.length];
                            };

                            return (
                                <div key={index} style={{
                                    display: 'grid',
                                    gridTemplateColumns: '60px 2fr 1fr 1fr 1fr 1fr 1fr',
                                    gap: '10px',
                                    alignItems: 'center',
                                    padding: '12px 10px',
                                    borderBottom: '1px solid #f1f5f9',
                                    backgroundColor: index % 2 === 0 ? '#ffffff' : '#f8fafc',
                                    borderRadius: '6px',
                                    marginBottom: '2px',
                                    minHeight: '40px'
                                }}>
                                    <span style={{
                                        color: '#1e293b',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        textAlign: 'center',
                                        padding: '8px',
                                        backgroundColor: getRowColor(index),
                                        borderRadius: '6px',
                                        minHeight: '28px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>
                                        {index + 1}
                                    </span>
                                    <span style={{
                                        color: '#334155',
                                        fontSize: '14px',
                                        padding: '8px 12px',
                                        backgroundColor: '#f1f5f9',
                                        borderRadius: '6px',
                                        wordBreak: 'break-word',
                                        minHeight: '28px',
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}>
                                        {item.description || 'N/A'}
                                    </span>
                                    {hiddenColumnsDescriptions.includes(item.description) ? (
                                        <span style={{
                                            color: '#1e293b',
                                            fontWeight: '500',
                                            fontSize: '13px',
                                            textAlign: 'right',
                                            padding: '6px',
                                            backgroundColor: '#ecfdf5',
                                            borderRadius: '6px',
                                            minHeight: '28px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'flex-end'
                                        }}>

                                        </span>
                                    ) : (
                                        <input
                                            type="text"
                                            value={inputValues[index]?.taxable_non_taxable_value !== '' && inputValues[index]?.taxable_non_taxable_value != null ? `₹${inputValues[index].taxable_non_taxable_value}` : ''}
                                            onChange={(e) => handleManualInputChange(index, 'taxable_non_taxable_value', e.target.value)}
                                            onKeyDown={handleKeyDown}
                                            style={{ ...inputStyle, backgroundColor: '#ecfdf5' }}
                                            onFocus={inputFocusBlur.onFocus}
                                            onBlur={(e) => inputFocusBlur.onBlur(e, index, 'taxable_non_taxable_value')}
                                        />
                                    )}
                                    <input
                                        type="text"
                                        value={inputValues[index]?.central_tax !== '' && inputValues[index]?.central_tax != null ? `₹${inputValues[index].central_tax}` : ''}
                                        onChange={(e) => handleManualInputChange(index, 'central_tax', e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        style={{ ...inputStyle, backgroundColor: '#fef3c7' }}
                                        onFocus={inputFocusBlur.onFocus}
                                        onBlur={(e) => inputFocusBlur.onBlur(e, index, 'central_tax')}
                                    />
                                    <input
                                        type="text"
                                        value={inputValues[index]?.state_tax_ut_tax !== '' && inputValues[index]?.state_tax_ut_tax != null ? `₹${inputValues[index].state_tax_ut_tax}` : ''}
                                        onChange={(e) => handleManualInputChange(index, 'state_tax_ut_tax', e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        style={{ ...inputStyle, backgroundColor: '#dbeafe' }}
                                        onFocus={inputFocusBlur.onFocus}
                                        onBlur={(e) => inputFocusBlur.onBlur(e, index, 'state_tax_ut_tax')}
                                    />
                                    <input
                                        type="text"
                                        value={inputValues[index]?.integrated_tax !== '' && inputValues[index]?.integrated_tax != null ? `₹${inputValues[index].integrated_tax}` : ''}
                                        onChange={(e) => handleManualInputChange(index, 'integrated_tax', e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        style={{ ...inputStyle, backgroundColor: '#f3e8ff' }}
                                        onFocus={inputFocusBlur.onFocus}
                                        onBlur={(e) => inputFocusBlur.onBlur(e, index, 'integrated_tax')}
                                    />
                                    <input
                                        type="text"
                                        value={inputValues[index]?.cess !== '' && inputValues[index]?.cess != null ? `₹${inputValues[index].cess}` : ''}
                                        onChange={(e) => handleManualInputChange(index, 'cess', e.target.value)}
                                        onKeyDown={handleKeyDown}
                                        style={{ ...inputStyle, backgroundColor: '#fce7f3' }}
                                        onFocus={inputFocusBlur.onFocus}
                                        onBlur={(e) => inputFocusBlur.onBlur(e, index, 'cess')}
                                    />
                                </div>
                            );
                        })
                    ) : (
                        <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
                            No data available for this section.
                        </div>
                    )}
                </div>

                {/* Summary or Footer */}
                {data && Array.isArray(data) && data.length > 0 && (
                    <div style={{
                        marginTop: '20px',
                        padding: '15px',
                        backgroundColor: '#f8fafc',
                        borderRadius: '8px',
                        borderTop: '2px solid #e2e8f0',
                    }}>
                        <p style={{ margin: '0', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
                            Total Records: {data.length}
                        </p>
                    </div>
                )}

                {/* Submit Button */}
                <div style={{
                    marginTop: '20px',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    height: '80px',
                }}>
                    <button
                        onClick={handleSubmit}
                        style={{
                            padding: '10px 20px',
                            background: 'linear-gradient(135deg, #ffd3a5 0%, #fd9853 50%, #e8a87c 100%)',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            boxShadow: '0 4px 12px rgba(255, 211, 165, 0.3)',
                            transition: 'all 0.2s ease',
                            minWidth: '80px',
                        }}
                        onMouseOver={(e) => {
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.boxShadow = '0 6px 16px rgba(255, 211, 165, 0.4)';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 4px 12px rgba(255, 211, 165, 0.3)';
                        }}
                    >
                        Submit
                    </button>
                </div>

                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                >
                    <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                        {snackbar.message}
                    </Alert>
                </Snackbar>
            </div>
        </div>
    );
}

export default Pvt;